import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'open-sans-fontface/open-sans.css';
import formatCpf from 'Support/filters/formatCpf';
import formatDate from 'Support/filters/formatDate';
import formatMoney from 'Support/filters/formatMoney';
import phone from 'Support/filters/formatTelephone';
import truncateFilter from 'Support/filters/truncateFilter';
import store from 'Support/store';
import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
import App from './App.vue';
import './plugins/froala';
import i18n from './plugins/i18n';
import './plugins/loading';
import './plugins/sweetalert2';
import './plugins/vuetify';
import './registerServiceWorker';
import router from './router';

Vue.filter('formatDate', formatDate);
Vue.filter('formatMoney', formatMoney);
Vue.filter('truncating', truncateFilter);
Vue.filter('phone', phone);
Vue.filter('cpf', formatCpf);

Vue.config.productionTip = false;
Vue.use(VueFroala);

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app');
